import { useState, useEffect } from "react";

export function useDebounce(value,delay=1000){
    const [debounceValue,setDebouncedValue]=useState(value);


    useEffect(()=>{
        const handler=setTimeout(()=>setDebouncedValue(value),delay)

        return ()=>clearTimeout(handler)
    },[value,delay])

    return debounceValue
}